import DiamondsChart from './DiamondsChart'

export default DiamondsChart
